// Place the URL here with the /api suffix.
// Ex.:`https://domain.com/api`;
const backendUrl = `https://api-prod-v2.soaak.com/api`;

// SwaggerUI Documentation URL
// Leave black if documentation should be hidden
const apiDocumentationUrl = `https://api-prod-v2.soaak.com/documentation`;

/**
 * Frontend URL.
 */
const frontendUrl = {
 host: 'soaak-prod-fe-alb-718068096.us-east-1.elb.amazonaws.com',
 protocol: 'http',
};

const marketingTermsOrServiceUrl =
  'https://soaak.com/terms-of-service/';
const marketingPrivacyPolicyUrl =
  'https://soaak.com/privacy-policy/';
const marketingReferAFriendUrl =
  'https://www.soaak.com/app';

/**
 * Tenant Mode
 * multi: Allow new users to create new tenants.
 * multi-with-subdomain: Same as multi, but enable access to the tenant via subdomain.
 * single: One tenant, the first user to register will be the admin.
 */
const tenantMode = 'single';

/**
 * Plan payments configuration.
 */
const isPlanEnabled = true;
const stripePublishableKey =
  'pk_live_51HYuIJI7OMFn2tF6C9vYrioF2dJmFgxILBjBhpwjJnVUGbUC404uKB9YZNtvNgPt9eS0ExJJ1X0h38dSdZ97pnGB009ny1Y4Lx';

const pixelId = '357164989128215';
const googleTagManagerId = 'GTM-K8BT3XB';

/**
 * Store ID mappings for different platforms and plans
 */
const storeIdMappings = {
  // Apple Store IDs
  'com.soaak.app.sleep.annual': 'Sleep Well Annual',
  'com.soaak.app.sleep.monthly': 'Sleep Well Monthly', 
  'com.soaak.app.premium.annualplan': 'Full Access Annual',
  'com.soaak.app.premium': 'Full Access Monthly',
  
  // Google Store IDs
  'google.sleep.annual': 'Sleep Well Annual',
  'google.sleep.monthly': 'Sleep Well Monthly',
  'google.premium.annual': 'Full Access Annual', 
  'google.premium.monthly': 'Full Access Monthly',
  
  // Web Store IDs
  'price_1Q3XCRI7OMFn2tF6f6rVlnIR': 'Sleep Well Annual',
  'price_1Q3X8RI7OMFn2tF65A4rmkXc': 'Sleep Well Monthly',
  'price_1MMbV0I7OMFn2tF6xel4rAtw': 'Full Access Annual',
  'price_1KOBVUI7OMFn2tF6OSHBdZUN': 'Full Access Monthly',
};

/**
 * Decode plan name from store ID
 * @param {string} storeId - The store ID to decode
 * @returns {string} - The plan name or 'Unknown Plan' if not found
 */
const decodePlanFromStoreId = (storeId) => {
  return storeIdMappings[storeId] || 'Unknown Plan';
};

export default {
  googleTagManagerId,
  pixelId,
  frontendUrl,
  backendUrl,
  apiDocumentationUrl,
  tenantMode,
  isPlanEnabled,
  stripePublishableKey,
  marketingTermsOrServiceUrl,
  marketingPrivacyPolicyUrl,
  marketingReferAFriendUrl,
  storeIdMappings,
  decodePlanFromStoreId,
};
